import React from "react";

import clsx from "clsx";
import { useHistory } from "react-router-dom";

import { TableRow, Tooltip, makeStyles } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles/colorManipulator";

import Compact from "./Compact";

const useStyles = makeStyles((theme) => ({
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: alpha(theme.palette.primary.main, 0.05),
    },
    "&:nth-of-type(even)": {
      backgroundColor: "transparent",
    },
    "&:not(.compact):hover, &.compact table tr:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
  },
  danger: {
    "&:nth-of-type(odd)": {
      backgroundColor: alpha(theme.palette.danger.main, 0.4),
    },
    "&:nth-of-type(even)": {
      backgroundColor: alpha(theme.palette.danger.main, 0.35),
    },
    "&:not(.compact):hover, &.compact table tr:hover": {
      backgroundColor: alpha(theme.palette.danger.main, 0.45),
    },
  },
  warning: {
    "&:nth-of-type(odd)": {
      backgroundColor: alpha(theme.palette.warning.main, 0.55),
    },
    "&:nth-of-type(even)": {
      backgroundColor: alpha(theme.palette.warning.main, 0.5),
    },
    "&:not(.compact):hover, &.compact table tr:hover": {
      backgroundColor: alpha(theme.palette.warning.main, 0.7),
    },
  },
  clickable: {
    cursor: "pointer",
    "&.compact:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
  },
}));

export default function Row({
  children,
  color,
  compact,
  link,
  row,
  tooltip,
  onClick,
}) {
  const classes = useStyles();
  const history = useHistory();

  function handleClick(e) {
    if (link) {
      if (typeof link !== "string") {
        link = link(row);
      }

      if (e.ctrlKey || e.metaKey || e.type === "auxclick") {
        window.open(link, "_blank");
      } else {
        history.push(link);
      }
    }
  }

  const className = clsx(classes.row, color && classes[color], {
    [classes.clickable]: link || onClick,
    compact,
  });

  const tableRow = (
    <TableRow
      className={className}
      onAuxClick={handleClick}
      onClick={handleClick}
    >
      {compact ? <Compact>{children}</Compact> : children}
    </TableRow>
  );

  return tooltip ? <Tooltip title={tooltip}>{tableRow}</Tooltip> : tableRow;
}
